<div class="success-page">
  <!-- Polling -->
  <div *ngIf="status === 'polling'" class="status-card">
    <p-progressSpinner strokeWidth="4" styleClass="status-spinner" />
    <h2 class="status-title">Processando seu pagamento...</h2>
    <p class="status-desc">Aguarde enquanto confirmamos sua assinatura. Isso pode levar alguns instantes.</p>
  </div>

  <!-- Success -->
  <div *ngIf="status === 'success'" class="status-card">
    <div class="success-icon">
      <i class="pi pi-check-circle"></i>
    </div>
    <h2 class="status-title">Assinatura ativada!</h2>
    <p class="status-desc">Seu plano foi ativado com sucesso. Redirecionando...</p>
  </div>

  <!-- Error / timeout -->
  <div *ngIf="status === 'error'" class="status-card">
    <div class="error-icon">
      <i class="pi pi-exclamation-circle"></i>
    </div>
    <h2 class="status-title">Verificação demorou mais que o esperado</h2>
    <p class="status-desc">
      Seu pagamento pode ter sido processado. Acesse o dashboard para verificar o status da sua assinatura.
    </p>
    <p-button label="Ir para o dashboard" icon="pi pi-home" (onClick)="goToDashboard()" class="p-button-cancel"/>
  </div>
</div>
